module.exports = __webpack_public_path__ + "static/media/filter.4fda5f06.png";